// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","tree":"Tree_tree__Wcb-M","treeItem":"Tree_treeItem__22mbJ","parent":"Tree_parent__F6NoW","value":"Tree_value__2QcQ5"};